// import React from "react";
// import { Container, Typography, Grid, Card, CardMedia, CardContent, Button, Box } from "@mui/material";
// import { Link } from "react-router-dom";

// const BlogPage = () => {
//   // Sample blog posts with thumbnail images
//   const blogPosts = [
//     {
//       id: 1,
//       title: "Facticity Wins ASEAN Digital Awards",
//       summary: "AI Seer's Facticity.AI, the Multimedia and Multilingual Fact-Checker, Wins ASEAN Digital Awards for Digital Content.",
//       date: "31 January, 2025",
//       imageUrl: "https://img.pr.com/w1303-h850/release/2501/546267/pressrelease_546267_1737618682.jpeg", // Replace with actual image URLs
//       link: "https://www.pr.com/press-release/929834"
//     },
//     {
//       id: 2,
//       title: "Facticity Wins TIME's Best Inventions 2024 in AI",
//       summary: "TIME revealed its annual list of the Best Inventions, which features 200 extraordinary innovations including AI Seer's Facticity.AI which is changing our lives.",
//       date: "October 30, 2024",
//       imageUrl: "https://img.pr.com/w1685-h850/release/2411/546267/pressrelease_546267_1730441961.jpeg",
//       link: "/blog/times-best-inventions"
//     },
//   ];

//   return (
//     <Container maxWidth="lg" sx={{ padding: "60px 0" }}>
//       <Typography variant="h3" gutterBottom align="center" sx={{ fontWeight: 600, color: "primary.main" }}>
//         Our Blog
//       </Typography>
//       <Grid container spacing={4}>
//         {blogPosts.map((post) => (
//           <Grid item xs={12} sm={6} md={4} key={post.id}>
//             <Card
//               sx={{
//                 display: "flex",
//                 flexDirection: "column",
//                 height: "100%",
//                 borderRadius: "12px",
//                 overflow: "hidden",
//                 transition: "transform 0.3s ease, box-shadow 0.3s ease",
//                 "&:hover": {
//                   transform: "translateY(-5px)",
//                   boxShadow: "0px 10px 30px rgba(0,0,0,0.15)",
//                 },
//               }}
//             >
//               <Box sx={{ position: "relative" }}>
//                 <CardMedia
//                   component="img"
//                   height="250"
//                   image={post.imageUrl}
//                   alt={post.title}
//                   sx={{
//                     filter: "brightness(90%)",
//                     transition: "filter 0.3s ease",
//                     "&:hover": { filter: "brightness(100%)" },
//                   }}
//                 />
//                 <Box
//                   sx={{
//                     position: "absolute",
//                     bottom: 0,
//                     left: 0,
//                     width: "100%",
//                     height: "30%",
//                     background: "linear-gradient(transparent, rgba(0,0,0,0.5))",
//                   }}
//                 />
//               </Box>
//               <CardContent sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
//                 <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
//                   {post.title}
//                 </Typography>
//                 <Typography variant="body2" color="textSecondary" sx={{ flexGrow: 1 }}>
//                   {post.summary}
//                 </Typography>
//                 <Typography variant="caption" color="textSecondary" sx={{ mt: 1 }}>
//                   Published on {post.date}
//                 </Typography>
//                 <Box sx={{ mt: 2 }}>
//                   <Link to={post.link} style={{ textDecoration: "none" }}>
//                     <Button variant="contained" color="primary" fullWidth>
//                       Read More
//                     </Button>
//                   </Link>
//                 </Box>
//               </CardContent>
//             </Card>
//           </Grid>
//         ))}
//       </Grid>
//     </Container>
//   );
// };

// export default BlogPage;
import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Button,
  Box,
  IconButton,
  Paper,
  useTheme,
  Fade,
  Chip
} from "@mui/material";
import { Link } from "react-router-dom";
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

const BlogPage = () => {
  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);

  const blogPosts = [
    {
      id: 1,
      title: "Facticity Wins ASEAN Digital Awards",
      summary: "AI Seer's Facticity.AI, the Multimedia and Multilingual Fact-Checker, Wins ASEAN Digital Awards for Digital Content.",
      date: "31 January, 2025",
      imageUrl: "https://img.pr.com/w1303-h850/release/2501/546267/pressrelease_546267_1737618682.jpeg",
      link: "https://www.pr.com/press-release/929834",
      category: "Awards"
    },
    {
      id: 2,
      title: "Facticity Wins TIME's Best Inventions 2024 in AI",
      summary: "TIME revealed its annual list of the Best Inventions, which features 200 extraordinary innovations including AI Seer's Facticity.AI which is changing our lives.",
      date: "October 30, 2024",
      imageUrl: "https://img.pr.com/w1685-h850/release/2411/546267/pressrelease_546267_1730441961.jpeg",
      link: "/blog/times-best-inventions",
      category: "Recognition"
    },
    {
      id: 3,
      title: "Facticity.AI fact checks the second presidential debate live",
      summary: "Facticity.AI delivers almost real-time fact-checking on the candidates' statements during the US Presidential Debate! ",
      date: "September 11, 2024",
      imageUrl: "https://storage.googleapis.com/public_resources_seer/Debate2.jpg",
      link: "/blog/harrisvtrump",
      category: "Fact-checks"
    },
    {
      id: 4,
      title: "Facticity.AI fact checks the first presidential debate live",
      summary: "Facticity.AI delivers almost real-time fact-checking on the candidates' statements during the US Presidential Debate! ",
      date: "June 27, 2024",
      imageUrl: "https://storage.googleapis.com/public_resources_seer/Debate.jpg",
      link: "/blog/bidenvtrump",
      category: "Fact-checks"
    },
  ];

  const maxSteps = blogPosts.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => (prevActiveStep + 1) % maxSteps);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => (prevActiveStep - 1 + maxSteps) % maxSteps);
  };

  useEffect(() => {
    let timer;
    if (autoPlay) {
      timer = setInterval(() => {
        handleNext();
      }, 5000);
    }
    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [activeStep, autoPlay]);

  const handleMouseEnter = () => setAutoPlay(false);
  const handleMouseLeave = () => setAutoPlay(true);

  return (
    <Box 
    sx={{
      minHeight: "100vh",
      background: "radial-gradient(circle at center, rgba(255, 255, 255, 1) 0%, #F1F3FE 60%, #F1F3FE 100%)",
      pt: 4,
      pb: 8
    }}
    >
      <Container maxWidth="lg">
        {/* Featured Post Section */}
        <Box 
          sx={{ 
            mb: 8,
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: -40,
              left: -200,
              right: -200,
              height: '500px',
              background: 'radial-gradient(circle at center, rgba(255, 255, 255, 1) 0%, #F1F3FE 60%, #F1F3FE 100%)',
              // background: 'linear-gradient(160deg, #f0f7ff 0%, #ffffff 100%)',
              zIndex: -1
            }
          }}
        >
          <Typography
            variant="h3"
            align="center"
            sx={{
              fontWeight: 800,
              color: ' #0066FF',
              mb: 1,
              fontSize: { xs: '2rem', md: '2.5rem' }
            }}
          >
            Latest Updates
          </Typography>
          <Typography
            variant="body1"
            align="center"
            sx={{
              color: '#666',
              mb: 6,
              maxWidth: '600px',
              mx: 'auto'
            }}
          >
            Discover our latest news, awards, and innovations
          </Typography>

          <Paper
            elevation={0}
            sx={{
              position: 'relative',
              borderRadius: '24px',
              overflow: 'hidden',
              backgroundColor: 'transparent'
            }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <Box sx={{ position: 'relative', height: { xs: 400, md: 600 } }}>
              {blogPosts.map((post, index) => (
                <Fade 
                  key={post.id} 
                  in={activeStep === index}
                  timeout={500}
                  sx={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    display: activeStep === index ? 'block' : 'none'
                  }}
                >
                  <Box sx={{ height: '100%', position: 'relative' }}>
                    <CardMedia
                      component="img"
                      height="100%"
                      image={post.imageUrl}
                      alt={post.title}
                      sx={{
                        objectFit: 'cover',
                        borderRadius: '24px',
                        filter: 'brightness(0.9)',
                      }}
                    />
                    <Box
                      sx={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        background: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.4) 50%, transparent 100%)',
                        padding: { xs: 3, md: 6 },
                        borderRadius: '0 0 24px 24px'
                      }}
                    >
                      <Chip 
                        label={post.category}
                        sx={{ 
                          backgroundColor: 'rgba(255,255,255,0.9)',
                          mb: 2,
                          fontWeight: 600
                        }}
                      />
                      <Typography 
                        variant="h4" 
                        gutterBottom
                        sx={{ 
                          color: 'white',
                          fontWeight: 700,
                          fontSize: { xs: '1.5rem', md: '2rem' }
                        }}
                      >
                        {post.title}
                      </Typography>
                      <Typography 
                        variant="body1" 
                        sx={{ 
                          color: 'rgba(255,255,255,0.9)',
                          mb: 3,
                          display: { xs: 'none', md: 'block' }
                        }}
                      >
                        {post.summary}
                      </Typography>
                      <Link to={post.link} style={{ textDecoration: "none" }}>
                        <Button 
                          variant="contained"
                          sx={{
                            textTransform: "none",
                            borderRadius: '12px',
                            px: 4,
                            py: 1.5,
                            fontSize: '1rem',
                            fontWeight: 600,
                            backgroundColor: 'white',
                            color: '#1a2027',
                            '&:hover': {
                              backgroundColor: 'rgba(255,255,255,0.9)',
                            }
                          }}
                        >
                          Read More
                        </Button>
                      </Link>
                    </Box>
                  </Box>
                </Fade>
              ))}
            </Box>
            <Box
              sx={{
                position: 'absolute',
                bottom: 20,
                right: 20,
                display: 'flex',
                gap: 1
              }}
            >
              <IconButton
                onClick={handleBack}
                disabled={activeStep === 0}
                sx={{ 
                  color: 'white',
                  backgroundColor: 'rgba(255,255,255,0.2)',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.3)',
                  }
                }}
              >
                <KeyboardArrowLeft />
              </IconButton>
              <IconButton
                onClick={handleNext}
                disabled={activeStep === maxSteps - 1}
                sx={{ 
                  color: 'white',
                  backgroundColor: 'rgba(255,255,255,0.2)',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.3)',
                  }
                }}
              >
                <KeyboardArrowRight />
              </IconButton>
            </Box>
          </Paper>
        </Box>

        {/* All Posts Section */}
        <Box sx={{ mb: 4 }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              color: ' #0066FF',
              mb: 4
            }}
          >
            All Posts
          </Typography>

          <Grid container spacing={3}>
            {blogPosts.map((post) => (
              <Grid item xs={12} md={6} key={post.id}>
                <Card
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    borderRadius: "24px",
                    overflow: "hidden",
                    border: "1px solid rgba(0,0,0,0.08)",
                    boxShadow: "none",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: "0px 12px 24px rgba(0,0,0,0.1)",
                    },
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <CardMedia
                      component="img"
                      height="300"
                      image={post.imageUrl}
                      alt={post.title}
                      sx={{
                        filter: "brightness(0.95)",
                      }}
                    />
                    <Chip
                      label={post.category}
                      sx={{
                        position: "absolute",
                        top: 16,
                        left: 16,
                        backgroundColor: "rgba(255,255,255,0.9)",
                        fontWeight: 600,
                      }}
                    />
                  </Box>

                  <CardContent
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      flexGrow: 1, // Allows the content to stretch, keeping the button at the bottom
                      p: 3,
                    }}
                  >
                    <Typography
                      variant="caption"
                      sx={{
                        color: "#666",
                        display: "block",
                        mb: 1,
                      }}
                    >
                      {post.date}
                    </Typography>
                    <Typography
                      variant="h5"
                      gutterBottom
                      sx={{
                        fontWeight: 700,
                        mb: 2,
                      }}
                    >
                      {post.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ flexGrow: 1, mb: 3 }} // This pushes the button down
                    >
                      {post.summary}
                    </Typography>

                    <Link to={post.link} style={{ textDecoration: "none" }}>
                      <Button
                        variant="outlined"
                        fullWidth
                        sx={{
                          textTransform: "none",
                          borderRadius: "12px",
                          py: 1.5,
                          fontSize: "0.95rem",
                          fontWeight: 600,
                          borderColor: "#1a2027",
                          color: "#1a2027",
                          "&:hover": {
                            borderColor: "#000",
                            backgroundColor: "rgba(0,0,0,0.04)",
                          },
                          mt: "auto", // Ensures it sticks to the bottom
                        }}
                      >
                        See More
                      </Button>
                    </Link>
                  </CardContent>
                </Card>
              </Grid>

            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default BlogPage;